module.exports = __webpack_public_path__ + "static/03-748704710607a277fc33572c82937868.jpg";